import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledAuthContent = styled(Grid)`
  display: grid;
  max-width: 640px;
  padding: 40px;
  gap: 56px;
  border-radius: 4px;
  background: ${colors.white};

  box-shadow: 0px 6px 10px 0px #c2ccf333;
  box-shadow: 0px 4px 8px 0px #c2ccf333;
  box-shadow: 0px 2px 6px 0px #c2ccf34d;
  box-shadow: 0px 2px 4px 0px #c2ccf359;
`;
